// src/admin/components/InventoryTable.js
import React from "react";
import { useMediaQuery } from "react-responsive";

export default function InventoryTable({
  items,
  onOpenMovement,
  onOpenHistory,
  onDeleteItem,
}) {
  // Determina se lo schermo è "mobile" (max 768px)
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Prodotti in Inventario</h2>

      {items.length === 0 ? (
        <p style={styles.noItems}>Nessun prodotto in inventario.</p>
      ) : isMobile ? (
        // ---------------------------------------------------
        // VISTA MOBILE (CARDS)
        // ---------------------------------------------------
        <div style={styles.cardsWrapper}>
          {items.map((item) => {
            const quantityFormatted = parseFloat(item.quantity || 0).toFixed(2);
            const costFormatted = item.cost_per_unit
              ? parseFloat(item.cost_per_unit).toFixed(2)
              : "—";

            return (
              <div key={item.id} style={styles.card}>
                <div style={styles.cardRow}>
                  <strong>Nome:</strong> {item.ingredient_name}
                </div>
                <div style={styles.cardRow}>
                  <strong>Quantità:</strong> {quantityFormatted}
                </div>
                <div style={styles.cardRow}>
                  <strong>Unità:</strong> {item.unit}
                </div>
                <div style={styles.cardRow}>
                  <strong>Costo Unitario:</strong> {costFormatted}
                </div>
                <div style={styles.mobileActions}>
                  <button
                    style={{ ...styles.actionBtn, backgroundColor: "#FF8C00" }}
                    onClick={() => onOpenMovement(item)}
                    title="Aggiungi/Sottrai quantità"
                  >
                    +/-
                  </button>
                  <button
                    style={{ ...styles.actionBtn, backgroundColor: "#FF6600" }}
                    onClick={() => onOpenHistory(item)}
                    title="Storico movimenti"
                  >
                    👁
                  </button>
                  <button
                    style={{ ...styles.actionBtn, backgroundColor: "#333" }}
                    onClick={() => onDeleteItem(item)}
                    title="Elimina prodotto"
                  >
                    🗑️
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        // ---------------------------------------------------
        // VISTA DESKTOP (TABELLA)
        // ---------------------------------------------------
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Nome</th>
              <th style={styles.th}>Quantità</th>
              <th style={styles.th}>Unità</th>
              <th style={styles.th}>Costo Unitario</th>
              <th style={styles.th}>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => {
              const quantityFormatted = parseFloat(item.quantity || 0).toFixed(2);
              const costFormatted = item.cost_per_unit
                ? parseFloat(item.cost_per_unit).toFixed(2)
                : "—";

              return (
                <tr key={item.id} style={styles.tr}>
                  <td style={styles.td}>{item.ingredient_name}</td>
                  <td style={styles.td}>{quantityFormatted}</td>
                  <td style={styles.td}>{item.unit}</td>
                  <td style={styles.td}>{costFormatted}</td>
                  <td style={{ ...styles.td, ...styles.actionsTd }}>
                    <button
                      style={{ ...styles.actionBtn, backgroundColor: "#FF8C00" }}
                      onClick={() => onOpenMovement(item)}
                      title="Aggiungi/Sottrai quantità"
                    >
                      +/-
                    </button>
                    <button
                      style={{ ...styles.actionBtn, backgroundColor: "#FF6600" }}
                      onClick={() => onOpenHistory(item)}
                      title="Storico movimenti"
                    >
                      👁
                    </button>
                    <button
                      style={{ ...styles.actionBtn, backgroundColor: "#333" }}
                      onClick={() => onDeleteItem(item)}
                      title="Elimina prodotto"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}

const styles = {
  // Contenitore principale
  container: {
    marginTop: 20,
    width: "100%",
  },

  heading: {
    margin: 0,
    marginBottom: 10,
    color: "#333",
    fontSize: "1.2rem",
    fontWeight: 600,
  },

  noItems: {
    color: "#333",
  },

  // ---------------------
  // STILI PER TABELLA DESKTOP
  // ---------------------
  table: {
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: "#FFF",
    border: "1px solid #EEE",
    borderRadius: "6px",
    textAlign: "left",
  },
  th: {
    padding: 10,
    borderBottom: "2px solid #EEE",
    color: "#333",
    fontWeight: "bold",
  },
  tr: {
    borderBottom: "1px solid #EEE",
  },
  td: {
    padding: 10,
    color: "#333",
    verticalAlign: "middle",
  },
  actionsTd: {
    display: "flex",
    gap: 8,
    justifyContent: "flex-start",
  },
  actionBtn: {
    cursor: "pointer",
    border: "none",
    color: "#FFF",
    padding: "6px 12px",
    borderRadius: "4px",
    fontWeight: "bold",
  },

  // ---------------------
  // STILI PER MOBILE (CARDS)
  // ---------------------
  cardsWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  card: {
    backgroundColor: "#FFF",
    border: "1px solid #EEE",
    borderRadius: 6,
    padding: 10,
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  },
  cardRow: {
    marginBottom: 6,
    color: "#333",
  },
  mobileActions: {
    display: "flex",
    gap: 8,
    marginTop: 6,
    justifyContent: "flex-start",
  },
};
